Attributes of the position opening.
